/* Cart drawer / side panels: proper mobile scroll lock.
   The theme locks the page with body{overflow:hidden} (.open-cc), which iOS
   Safari ignores, so the page kept scrolling behind the cart drawer. This
   wraps OverlayManager to add the same position:fixed body lock the Blade
   mobile menu drawer already uses. Load after app.js. */
(function () {
  if (typeof OverlayManager === 'undefined' || OverlayManager.__scrollLockPatched) return;
  OverlayManager.__scrollLockPatched = true;

  var savedY = 0;

  function lock() {
    savedY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-savedY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlock() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    var html = document.documentElement;
    var prev = html.style.scrollBehavior; /* html has scroll-behavior:smooth */
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedY);
    html.style.scrollBehavior = prev;
  }

  var origOpen = OverlayManager.open.bind(OverlayManager);
  var origClose = OverlayManager._close.bind(OverlayManager);

  OverlayManager.open = function (panel) {
    var wasLocked = document.body.style.position === 'fixed';
    origOpen(panel);
    if (!wasLocked && this.stack.length) lock();
  };

  OverlayManager._close = function (panel) {
    origClose(panel);
    if (!this.stack.length) unlock();
  };
})();
